import { useState, useEffect } from 'react'
import './RecruitBanner.css'

export default function RecruitBanner() {
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem('recruit_banner_dismissed') === 'true'
  )

  const [positions, setPositions] = useState(null)

  useEffect(() => {
    fetch('/config.json')
      .then(r => r.json())
      .then(d => setPositions(d.openPositions))
      .catch(() => setPositions(8)) // Fallback de sécurité
  }, [])

  if (dismissed || positions === null) return null

  function dismiss() {
    sessionStorage.setItem('recruit_banner_dismissed', 'true')
    setDismissed(true)
  }

  return (
    <div className="recruit-banner">
      <span className="recruit-banner__dot" />
      <span className="recruit-banner__text">
        On recrute !{' '}
        <a
          href="https://recrutements.stellarfm.fr"
          target="_blank"
          rel="noopener noreferrer"
          className="recruit-banner__link"
        >
          {positions} postes ouverts — Rejoins l'équipe StellarFM →
        </a>
      </span>
      <button className="recruit-banner__close" onClick={dismiss} aria-label="Fermer">✕</button>
    </div>
  )
}
